<template>
  <div>
    <table class="table">
      <thead class="thead-light">
        <tr>
          <th>Name</th>
          <th>Last Updated</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="etemp in etemplates" :key="etemp.id">
          <td><a href="" @click.prevent="template=etemp">{{ etemp.title }}</a></td>
          <td>{{ calendar(etemp.updated_at) }}</td>
        </tr>
      </tbody>
    </table>
    <modal @closed="close" :template="template"></modal>
  </div>
</template>

<script>

import api from '@/api'
import Modal from '@/components/settings/EmailTemplateModal.vue'
import moment from 'moment'

export default {
  name: 'dashboard',

  components: {
    Modal
  },

  data() {
    return {
      etemplates: [],
      template: {}
    }
  },

  methods: {
    calendar(date) {
      return moment(date).calendar()
    },

    close() {
      this.template = {}
    }
  },

  created() {
    api.get('/email-templates').then(res => {
      this.etemplates = res.data.email_templates
    })
  }
}
</script>
